// assets
import { DashboardOutlined, HomeOutlined, ApartmentOutlined, FileProtectOutlined } from '@ant-design/icons';
import { DollarCircleOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  HomeOutlined,
  ApartmentOutlined,
  FileProtectOutlined
  ,DollarCircleOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id:'province',
      title:'Province',
      type:'item',
      url:'/dashboard/province',
      icon:icons.ApartmentOutlined,
      breadcrumbs:false
    },
    {
      id:'province-rule',
      title:'Province-Rule',
      type:'item',
      url:'/dashboard/province-rules',
      icon:icons.FileProtectOutlined,
      breadcrumbs:false
    },
       {
      id: 'properties',
      title: 'Properties',
      type: 'item',
      url: '/dashboard/properties',
      icon: icons.HomeOutlined,
      breadcrumbs: false
    },
      {
        id:'leases',
        title:'Leases',
        type:'item',
        url:'/dashboard/leases',
        icon:icons.FileProtectOutlined,
        breadcrumbs:false
      },
      {
        id:'payments',
        title:'Payments',
        type:'item',
        url:'/dashboard/payments',
        icon:icons.DollarCircleOutlined,
        breadcrumbs:false
      },
      {
        id:'notices',
        title:'Notices',
        type:'item',
        url:'/dashboard/notices',
        icon:icons.FileProtectOutlined,
        breadcrumbs:false
      },
      
    
 
  ]
};

export default dashboard;
